// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item_2XNSt","active":"active_229Jm","title":"title_12Wvn","content":"content_L4q4m"};